import clsx from 'clsx'
import { MouseEventHandler } from 'react'

type SearchBadgeProps = {
  label: string
  isSelected: boolean
  onClickSelected: MouseEventHandler<HTMLButtonElement>
  onClickUnselected: MouseEventHandler<HTMLButtonElement>
}

export function SearchBadge (props: SearchBadgeProps) {
  const { label, isSelected, onClickSelected, onClickUnselected } = props

  return (
    <button
      className={clsx(
        'btn btn-sm rounded-lg manrope-bold',
        { 'btn-secondary': isSelected, 'btn-primary': !isSelected }
      )}
      onClick={isSelected ? onClickSelected : onClickUnselected}
    >
      {label}
    </button>
  )
}
